export default "__VITE_ASSET__eD_BHa2U__"